import { render, staticRenderFns } from "./CardBinding.vue?vue&type=template&id=29214eda&scoped=true"
import script from "./CardBinding.vue?vue&type=script&lang=js"
export * from "./CardBinding.vue?vue&type=script&lang=js"
import style0 from "./CardBinding.vue?vue&type=style&index=0&id=29214eda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29214eda",
  null
  
)

export default component.exports